import script from "./PropertyCompactList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropertyCompactList.vue?vue&type=script&setup=true&lang=ts"

import "./PropertyCompactList.vue?vue&type=style&index=0&id=b7fd9978&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7fd9978"]])

export default __exports__